import { useEffect, useState } from 'react';

const STORAGE_KEY = 'checkmate-mall-popup-hidden';

export const usePopupVisibility = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasReachedReviews, setHasReachedReviews] = useState(false);

  // localStorage 체크: "오늘 하루 안 보기" 여부
  useEffect(() => {
    const hideUntil = localStorage.getItem(STORAGE_KEY);
    if (hideUntil) {
      const hideUntilTime = parseInt(hideUntil, 10);
      if (Date.now() < hideUntilTime) return;
      localStorage.removeItem(STORAGE_KEY);
    }

    // Reviews 영역 스크롤 감지
    const reviewsSection = document.getElementById('reviews-section');
    if (!reviewsSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasReachedReviews(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(reviewsSection);

    return () => observer.disconnect();
  }, []);

  // Reviews 영역에 도달하면 팝업 표시
  useEffect(() => {
    if (hasReachedReviews) {
      setIsVisible(true);
    }
  }, [hasReachedReviews]);

  const hideForToday = () => {
    const tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    localStorage.setItem(STORAGE_KEY, tomorrow.getTime().toString());
    setIsVisible(false);
  };

  const hideForSession = () => {
    setIsVisible(false);
  };

  return {
    isVisible,
    hideForToday,
    hideForSession,
  };
};
